import { render } from "./addNewDIDNumberPopUp.vue?vue&type=template&id=51ec263c"
import script from "./addNewDIDNumberPopUp.vue?vue&type=script&lang=js"
export * from "./addNewDIDNumberPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__